import { Reducers } from '@sda/enums/store';
import { PublicThreadMask } from '@sda/sdk/masks';
import { ProfileTypes } from '@sda/enums';
import { SDKFactory } from './helpers/sdk.factory';
import { SDK } from './helpers/sdk';
import type { FirestoreClientData } from './interfaces';
import type { TypingState } from '@sda/interfaces/thread/typingstate';
import type { Thread } from '@sda/interfaces/thread';
import type { NormalizedPublicProfile } from '@sda/interfaces/show';

/**
 * SDK Class to interact with Firestore Acts.
 */
export class Threads extends SDK<Thread> {
  constructor(apiClient: FirestoreClientData) {
    super(apiClient, Reducers.THREADS);

    this.collection = this.fsh.Schema.PublicThreads;

    this.PublicMap = PublicThreadMask;
  }

  TypingStates(id: string): SDK<TypingState> {
    return SDKFactory(
      this.fsh.clientData,
      this.fsh.getCollection<TypingState>(this.fsh.Schema.PublicThreads, id, 'TypingStates'),
      { reducerName: Reducers.TYPING_STATES },
    );
  }

  PublicProfiles(id: string): SDK<NormalizedPublicProfile> {
    // For brevity, this is referred to in the code as PublicProfiles but the actual collection is PublicThreadProfiles
    // This makes collection group queries possible, in order to not conflict with the PublicShowProfiles collection
    return SDKFactory(
      this.fsh.clientData,
      this.fsh.getCollection<NormalizedPublicProfile>(this.fsh.Schema.PublicThreads, id, 'PublicThreadProfiles'),
      {
        reducerName: (profile) => {
          if (profile.profileType === ProfileTypes.ACT) {
            return Reducers.ACTS;
          }

          if (profile.profileType === ProfileTypes.VENUE) {
            return Reducers.VENUES;
          }

          return Reducers.PROFILES;
        },
      },
    );
  }
}
